import React, { useState, useEffect } from "react";
import axios from "axios";

function WeatherForecast(props) {
  let [loaded, setLoaded] = useState(false);
  let [forecastData, setForecastData] = useState({});

  useEffect(() => {
    setLoaded(false);
  }, [props.data.city])
  function handleForecastResponse(response) {
    setForecastData(response.data.daily);
    setLoaded(true);
  }

  function formatDay(timestamp) {
    let date = new Date(timestamp * 1000);
    let day = date.getDay();
    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return days[day];
  }

      function convertToCelsius(fahrenheit) {
        return ((fahrenheit - 32) * 5) / 9;
      }

  function renderForecast(dailyForecast, index, unit) {
      if (index <= 5 && index > 0) {
        return (
          <div className="forecast-day" key={index}>
            <div className="forecast-date">{formatDay(dailyForecast.time)}</div>
            <div>
              <img
                className="forecast-day-icon"
                src={dailyForecast.condition.icon_url}
                alt={dailyForecast.condition.icon}
              />
            </div>
            <div className="forecast-temperatures">
              <div className="forecast-temp max">{Math.round(unit === "imperial" ? dailyForecast.temperature.maximum : convertToCelsius(dailyForecast.temperature.maximum))}&deg;</div>
              <div className="forecast-temp min">{Math.round(unit === "imperial" ? dailyForecast.temperature.minimum : convertToCelsius(dailyForecast.temperature.minimum))}&deg;</div>
            </div>
          </div>
        );
      } else {
        return null;
      }
      }

  if (loaded) {

   
    return (
      <div className="weather-forecast">{forecastData.map((dailyForecast, index) => renderForecast(dailyForecast, index, props.unit))}</div>
    );
  } else {
    let city = props.data.city;
    let apiKey = "d723abdbd1batbf0d4fo3fa95586fbba";
    let apiURL = `https://api.shecodes.io/weather/v1/forecast?query=${city}&key=${apiKey}&units=imperial`;
    axios.get(apiURL).then(handleForecastResponse);
    return "Loading...";
  }
}
export default WeatherForecast;
